export const videolar = {
    title: 'Videolar',
    titleEN: 'Videos',
    description: 'Yemek.com\'da yayınlanan yemek tarifi ve püf noktası videoları',
    descriptionEN: 'Recipe and cooking tips videos published on Yemek.com',
    tabs: [
        {
            id: 1,
            title: 'Food Video',
            sliderPerView: 3,
            width: '100%',
            slides: [
                {
                    id: 1,
                    name: 'Yemekcom x Pekfood  -  IG Reels',
                    image: 'https://srv-cdn.onedio.com/store/dfb8f312a59b48b961e5d81cdc905f129c747af38479c4378849613fc87edc7c.png',
                    url: "https://www.instagram.com/p/DHDrPWZNCE0/"
                },
                {
                    id: 2,
                    name: 'Yemekcom x Doğanay  -  IG Reels',
                    image: 'https://srv-cdn.onedio.com/store/3abe480064c469f58c566636a3bcedb8a4815cbed87c1e7cfabfe65991167913.png',
                    url: "https://www.instagram.com/p/DHBGfyaNtaV/"
                },
                {
                    id: 3,
                    name: 'Yemekcom x Milka  -  IG Reels',
                    image: 'https://srv-cdn.onedio.com/store/e947a24f1c1ebb46f08cf68b1c2081a4155faaae9aeebe24485b5ed384dd6738.png',
                    url: "https://www.instagram.com/reel/DHqn04Bt9lX/?igsh=MnlobGE0NHV1bTd0"
                }
            ]
        },
        {
            id: 2,
            title: 'Youtube Shorts',
            sliderPerView: 2,
            width: '100%',
            slides: [
                {
                    id: 1,
                    name: 'Yemekcom x Porland',
                    image: 'https://srv-cdn.onedio.com/store/1cead1af82e77c7ef76177e784182e5e4251a7db1fdf18ca3f899b07b79e651f.png',
                    url: "https://www.youtube.com/shorts/xw2UUiHw-Nw"

                },
                {
                    id: 2,
                    name: 'Yemekcom x Amazon.com.tr',
                    image: 'https://srv-cdn.onedio.com/store/9b8676e2e9dd632258ad064f5b871e570dbe470e27f712980a50f005df1cbdcd.png',
                    url: "https://www.youtube.com/shorts/At19g4P0xbc"

                }
            ]
        },
        {
            id: 3,
            title: 'Experience Video',
            sliderPerView: 3,
            width: '100%',
            slides: [
                {
                    id: 1,
                    name: 'Şefle Ye',
                    image: 'https://srv-cdn.onedio.com/store/5da0102a256d6579c4542ecacf1cc36336b2d9a8424687c8ef2df319dd260bfe.png',
                    url: "https://www.youtube.com/watch?v=cnyYuBokt3k"

                },
                {
                    id: 2,
                    name: 'Şefle Ye - Kadıköy Yemek Rotası',
                    image: 'https://srv-cdn.onedio.com/store/98df2611d2d3b34168a2da1a042c6860ac55a7efc468bec847549702a699176f.png',
                    url: "https://www.youtube.com/watch?v=3fC2sB3SZvk"

                },
                {
                    id: 3,
                    name: 'Bursa Yemek Turu',
                    image: 'https://srv-cdn.onedio.com/store/199a8079dfe58de766537dd9da41f06ecb6ff1d19e39d92a676296fee2bfe2c3.png',
                    url: "https://www.youtube.com/watch?v=PP2dR0pOT1I&list=PLEPNSil4Fq5LD111S59rsftA95vG9wsi5"

                }
            ]
        }
    ],
    egTabs: [
        {
            id: 1,
            title: 'Food Videos',
            sliderPerView: 3,
            width: '100%',
            slides: [
                {
                    id: 1,
                    name: 'Yemekcom x Pekfood  -  IG Reels',
                    image: 'https://srv-cdn.onedio.com/store/dfb8f312a59b48b961e5d81cdc905f129c747af38479c4378849613fc87edc7c.png',
                    url: "https://www.instagram.com/p/DHDrPWZNCE0/"
                },
                {
                    id: 2,
                    name: 'Yemekcom x Doğanay  -  IG Reels',
                    image: 'https://srv-cdn.onedio.com/store/3abe480064c469f58c566636a3bcedb8a4815cbed87c1e7cfabfe65991167913.png',
                    url: "https://www.instagram.com/p/DHBGfyaNtaV/"
                },
                {
                    id: 3,
                    name: 'Yemekcom x Milka  -  IG Reels',
                    image: 'https://srv-cdn.onedio.com/store/e947a24f1c1ebb46f08cf68b1c2081a4155faaae9aeebe24485b5ed384dd6738.png',
                    url: "https://www.instagram.com/reel/DHqn04Bt9lX/?igsh=MnlobGE0NHV1bTd0"
                }
            ]
        },
        {
            id: 2,
            title: 'Youtube Shorts',
            sliderPerView: 2,
            width: '100%',
            slides: [
                {
                    id: 1,
                    name: 'Yemekcom x Porland',
                    image: 'https://srv-cdn.onedio.com/store/1cead1af82e77c7ef76177e784182e5e4251a7db1fdf18ca3f899b07b79e651f.png',
                    url: "https://www.youtube.com/shorts/xw2UUiHw-Nw"

                },
                {
                    id: 2,
                    name: 'Yemekcom x Amazon.com.tr',
                    image: 'https://srv-cdn.onedio.com/store/9b8676e2e9dd632258ad064f5b871e570dbe470e27f712980a50f005df1cbdcd.png',
                    url: "https://www.youtube.com/shorts/At19g4P0xbc"

                }
            ]
        },
        {
            id: 3,
            title: 'Experience Video',
            sliderPerView: 3,
            width: '100%',
            slides: [
                {
                    id: 1,
                    name: 'Şefle Ye',
                    image: 'https://srv-cdn.onedio.com/store/5da0102a256d6579c4542ecacf1cc36336b2d9a8424687c8ef2df319dd260bfe.png',
                    url: "https://www.youtube.com/watch?v=cnyYuBokt3k"

                },
                {
                    id: 2,
                    name: 'Şefle Ye - Kadıköy Yemek Rotası',
                    image: 'https://srv-cdn.onedio.com/store/98df2611d2d3b34168a2da1a042c6860ac55a7efc468bec847549702a699176f.png',
                    url: "https://www.youtube.com/watch?v=3fC2sB3SZvk"

                },
                {
                    id: 3,
                    name: 'Bursa Yemek Turu',
                    image: 'https://srv-cdn.onedio.com/store/199a8079dfe58de766537dd9da41f06ecb6ff1d19e39d92a676296fee2bfe2c3.png',
                    url: "https://www.youtube.com/watch?v=PP2dR0pOT1I&list=PLEPNSil4Fq5LD111S59rsftA95vG9wsi5"

                }
            ]
        }
    ]
} 